import { memo } from "react";
import applicationQualificationTitleIcon from "../assets/img/Desktop/Meteor_scholarship_4_D.png";
import applicationQualificationMemberIcon from "../assets/img/Desktop/Meteor_scholarship_5_D.png";
import applicationQualificationTranscriptIcon from "../assets/img/Desktop/Meteor_scholarship_6_D.png";
import applicationQualificationPostsIcon from "../assets/img/Desktop/Meteor_scholarship_7_D.png";
import plusIcon from "../assets/img/Desktop/Meteor_component_7_D.png";
import MaxWidthLayout from "./MaxWidthLayout";

const ApplicationQualificationItem = ({
  imgSrc,
  imgAlt,
  title,
  context,
  styles,
  mobileStyles,
  titleStyles,
}) => {
  return (
    <div
      className={`flex justify-center items-center xl:block xl:w-32% ${styles}`}
    >
      <img
        src={imgSrc}
        alt={imgAlt}
        className="m-0 xl:m-auto max-w-64px md:max-w-216px"
      />
      <div className="flex xl:block flex-col justify-center pl-16px xl:pl-0">
        <p
          className={`text-yellow-1 text-lg md:text-28px pt-0 xl:pt-24px max-w-none ${styles} ${titleStyles}`}
        >
          {title}
        </p>
        <p
          className={`font-normal text-14px md:text-lg pt-8px md:pt-16px xl:pt-24px  ${mobileStyles} md:max-w-515px ${styles}`}
        >
          {context}
        </p>
      </div>
    </div>
  );
};

const ApplicationQualification = () => {
  return (
    <div
      id="applicationQualification"
      className="bg-applicationQualification text-white text-center font-semibold mt-64px md:mt-112px py-40px md:py-80px"
    >
      <MaxWidthLayout>
        <img
          src={applicationQualificationTitleIcon}
          alt="申請資格圖案"
          className="m-auto w-263px md:w-552px"
        />
        <p className="text-lg md:text-28px pt-16px">大專院校生 ＋ 高中職生</p>
        <p className="text-26px text-yellow-1 md:text-4xl pt-24px md:pt-36px">
          每名5,000元新台幣 共21位
        </p>
        <p className="text-lg md:text-28px pt-8px md:pt-16px">
          總獎學金額 105,000元
        </p>
        <p className="text-14px md:text-2xl pt-24px md:pt-36px pb-48px md:pb-64px ">
          收件日期：2023/8/22 - 2023/10/11
        </p>
        <div className="block xl:flex justify-between w-90% md:w-80% m-auto items-start relative text-start xl:items-stretch xl:text-center">
          <ApplicationQualificationItem
            imgSrc={applicationQualificationMemberIcon}
            imgAlt={"申請條件會員"}
            title={"Meteor學生社群註冊會員"}
            context={"下載Meteor學生社群，上傳學生證審核通過後及成為Meteor會員"}
            mobileStyles={"max-w-211px"}
            styles={" xl:max-w-319px"}
          />
          {/* <p className=" flex justify-center py-24px xl:hidden"> */}
          <p className=" xl:flex-1 flex justify-center relative py-24px xl:py-0">
            <img
              src={plusIcon}
              alt="加號"
              className="w-24px h-24px xl:absolute xl:top-69%"
            />
          </p>
          <ApplicationQualificationItem
            imgSrc={applicationQualificationTranscriptIcon}
            imgAlt={"申請條件成績"}
            title={"學年度總平均80分以上"}
            context={
              "111學年度上下學期成績總平均80分以上，且各科成績全部及格者"
            }
            mobileStyles={"max-w-211px"}
            styles={"  xl:max-w-291px"}
            // titleStyles={
            //   "relative xl:before:content-[''] before:w-24px before:h-24px before:bg-cover xl:before:bg-plus before:absolute before:-left-8% xl:after:content-[''] after:w-24px after:h-24px after:bg-cover xl:after:bg-plus after:absolute after:-right-8%"
            // }
          />
          {/* <p className=" flex justify-center py-24px xl:hidden
          "> */}
          <p className=" xl:flex-1 flex justify-center relative  py-24px xl:py-0">
            <img
              src={plusIcon}
              alt="加號"
              className="w-24px h-24px xl:absolute xl:top-69%"
            />
          </p>
          <ApplicationQualificationItem
            imgSrc={applicationQualificationPostsIcon}
            imgAlt={"申請條件文章"}
            title={"在Meteor板上發表文章"}
            context={"發表看板(廢文板除外)及內容不限，須符合板規"}
            mobileStyles={"max-w-223px"}
            styles={"xl:max-w-291px"}
          />
          {/* <div>
          <img src={applicationQualificationMemberIcon} alt="申請條件會員" />
          <p>Meteor學生社群註冊會員</p>
          <p>下載Meteor學生社群，上傳學生證審核通過後及成為Meteor會員</p>
        </div>
        <div>
          <img
            src={applicationQualificationTranscriptIcon}
            alt="申請條件成績"
          />
          <p>總平均80分以上</p>
          <p>110學年度上下學期成績總平均80分以上，且各科成績全部及格者</p>
        </div>
        <div>
          <img src={applicationQualificationPostsIcon} alt="申請條件文章" />
          <p>在Meteor板上發表文章</p>
          <p>在升學課業板、語言學習板、筆記板或職科板分享3篇讀書方法或心得</p>
        </div> */}
        </div>
      </MaxWidthLayout>
    </div>
  );
};

export default memo(ApplicationQualification);
